import { PiCircleDashed, PiSealCheckBold } from 'react-icons/pi';
import { TbClockHour3 } from 'react-icons/tb';
import { EstadoTarefaModal } from '@/modules/system/notificacoes/ModalTarefaNotificacao';

const TAMANHO_ICONE = 22;

const CORES: Record<EstadoTarefaModal, string> = {
  sem_tarefa: '#6c757d',
  em_atendimento: '#fd7e14',
  atendida: '#198754',
};

const TITULOS: Record<EstadoTarefaModal, string> = {
  sem_tarefa: 'Sem tarefa',
  em_atendimento: 'Em atendimento',
  atendida: 'Atendida',
};

interface IconeTarefaNotificacaoProps {
  estado: EstadoTarefaModal;
}

export default function IconeTarefaNotificacao({ estado }: IconeTarefaNotificacaoProps) {
  const cor = CORES[estado];
  const title = TITULOS[estado];

  switch (estado) {
    case 'sem_tarefa':
      return (
        <PiCircleDashed size={TAMANHO_ICONE} title={title} color={cor} aria-hidden />
      );
    case 'em_atendimento':
      return (
        <TbClockHour3 size={TAMANHO_ICONE} title={title} color={cor} aria-hidden />
      );
    case 'atendida':
      return (
        <PiSealCheckBold size={TAMANHO_ICONE} title={title} color={cor} aria-hidden />
      );
  }
}
